if (!customElements.get('hn-size-guide')) {
  customElements.define('hn-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const controls = this.querySelector('[data-size-units]');
      if (!controls) return;
      const select = (unit) => {
        this.querySelectorAll('[data-size-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sizeUnit === unit)));
        this.querySelectorAll('[data-size-table]').forEach(table => { table.hidden = table.dataset.sizeTable !== unit; });
      };
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-size-unit]');
        if (button) select(button.dataset.sizeUnit);
      });
      select('in');
      controls.hidden = false;
    }
  });
}
